
import React, { Component } from "react";
import Toolbar from '@material-ui/core/Toolbar';

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

//Actions
import { 
    getAllRepairs, getOpenRepairs, getCloseRepairs, 
    updRepair, ScheduleWorkOrder, CloseRepairs, 
    CancelRepairs, getHistoricDashboard,
    GetRepairsFilters
} from '../../actions/repairAction';
import { getAllItemsIcons } from '../../actions/itemAction';
import { SetHeaderButtons } from '../../actions/headerButtonsActions';
import { getAllCommunities } from '../../actions/communityActions'


import Alert from 'react-s-alert';
import { currentScrollingPage, itemPerPage } from "../../constants/index";


//3 party Libs
import moment from 'moment';

//Material UI Components

import Modal from '@material-ui/core/Modal'
import Paper from '@material-ui/core/Paper'
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Box from '@material-ui/core/Box';
import { Button, InputAdornment, TextField } from "@material-ui/core";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from '@material-ui/core/Grid';
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';

import SwipeableViews from 'react-swipeable-views';

//Engage Components
import { ChevronList } from '../../utils/engageComponents'
import { sweetAlert } from "../../components/Alert/sweetAlert";


//Views
import RepairsDashboard from './RepairsDashboard';
import RepairDetails from './RepairDetails';
import ModalCloseRepairs from './ModalCloseRepairs';
import AddRepairView from './AddRepairView'

//Icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { SuperUserDropDown } from '../../components/SuperUserDropDown/SuperUserDropDown';
import {UpdateCurrentLocation} from '../../actions/currentUrlActions';
import RepairsFilters from "./RepairsFilters";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort, faSortAlphaDown, faSortAlphaUpAlt, faSortNumericDown, faSortNumericUpAlt, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    <Grid container>{children}</Grid>
                </Box>
            )}
        </div>
    );
};


TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const initFilters={
    statusSelected:[],
    dateChanged:false,
    dateOptionSelected: '',
    startDate: new Date(),
    endDate: new Date(),
    itemsSelected: [],
    issuesSelected: [],
    responseTime: false,
    responseOption: 'Greater than',
    lowerLimit: 1,
    upperLimit: 10,
    responseUnit:'hours'
}



export class Repairs extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            tableData: [],
            isLoading: false,
            currentPageClosed: currentScrollingPage,
            currentPageOpended: currentScrollingPage,
            itemPerPage: itemPerPage,
            isRefreshedNeded: false,
            //Tabs
            tabValue: 0,
            //Community
            superUserCommunitySelected: undefined,
            superUserActivitiesLoaddedForCommunity: undefined,
            //repairsSelected
            repairsSelected: [],
            //selectAllButon
            selectAllButton: false,
            //ShowScheduleRepairModal
            showScheduleRepairModal: false,
            //scehduleRepairModal
            hourSelected: undefined,
            minuteSelected: undefined,
            dayTime: undefined,
            scheduleDay: undefined,
            fixedOptionSelected: undefined,
            disabledBackIcon: true,
            disabledFowardIcon: false,
            stepCounter: 0,

            //Close Repairs Modal
            showModalCloseRepairs: false,
            //Repair Details
            openRepairDetails: undefined,
            repairSelectedForDetails: undefined,
            repairSelectedForDetailsStatus: undefined,
            //LastTimeAutomaticReschedule
            LastTimeAutomaticReschedule: undefined,
            //rootFontSize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
            // cancel repairs
            isCancel: false,
            openCommunityCombo: false,

            filtersOpenedAnchorEl: null,
            filtersClosedAnchorEl:null,
            
            filtersOpenedObj: { ...initFilters, statusSelected:[],itemsSelected: [], issuesSelected: [] },
            filtersClosedObj: { ...initFilters, statusSelected:[],itemsSelected: [], issuesSelected: [] },

            filtersOpenedApply:false,
            filtersClosedApply:false,

            openSearchOpened: false,
            searchOpenedValue: '',

            openSearchClosed: false,
            searchClosedValue: '',

            sortOpenedColumn: 'createdDate',
            sortOpenedDesc: false,

            sortClosedColumn: 'createdDate',
            sortClosedDesc: false,

            //Add Repair
            showAddRepairView: false,

            stillOpen: true,
            stillClose: true

        };
        this.observer = React.createRef();
        this.lastOpenRef = node => {
            /* FUNCION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver( async(entries) => {
                const openNodes = document.querySelectorAll('[id^="Repairs_row_"]')
                let nextToEndNode = (openNodes && openNodes.length > 0)?openNodes[openNodes.length-1]: undefined
                const nodeList = document.querySelectorAll('[data-lastelementopen $="Last_Element_Open"]');
                let node = (nodeList && nodeList.length> 0)? nodeList[0]: undefined;

                if (entries[0].isIntersecting) {
                    if(nextToEndNode){
                        nextToEndNode.scrollIntoView(false);
                    }

                    if(node){
                        node= undefined;
                    }
                    const newCurrentPage = this.state.currentPageOpended? this.state.currentPageOpended +1: 1;
                    const res = await this.getOpenScrollingRepair(newCurrentPage)

                    this.setState((prevState) => ({ currentPageOpended: newCurrentPage , stillOpen: res}));
                    
                    setTimeout(() => this.forceUpdate(), 1000);
                }
            });
            if (node) this.observer.current.observe(node)
        };
        this.lastCloseRef = node => {
            /* FUNCION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver(async (entries) => {

                const openNodes = document.querySelectorAll('[id^="repair_closed_"]')
                let nextToEndNode = (openNodes && openNodes.length > 0)?openNodes[openNodes.length-1]: undefined
                const nodeList = document.querySelectorAll('[data-lastelementclose $="Last_Element_Close"]');
                let node = (nodeList && nodeList.length> 0)? nodeList[0]: undefined;

                if (entries[0].isIntersecting) {
                    if(nextToEndNode){
                        nextToEndNode.scrollIntoView(false);
                    }

                    if(node){
                        node= undefined;
                    }
                    const newCurrentPage = this.state.currentPageClosed? this.state.currentPageClosed +1: 1;
                    const res = await this.getCloseScrollingRepair(newCurrentPage)
                    this.setState((prevState) => ({ currentPageClosed: newCurrentPage , stillClose: res}),);

                    // this.setState((prevState) => ({ currentPageClosed: prevState.currentPageClosed + 1 }));
                    // this.getCloseScrollingRepair();
                    setTimeout(() => this.forceUpdate(), 1000);
                }
            });
            if (node) this.observer.current.observe(node)
        };
    }

    componentDidMount() {
        document.title='Repairs - Dashboard'

        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        if (!this.props.communityData || (this.props.communityData && this.props.communityData.length === 0)) {
            this.props.getAllCommunities();
        }

        if (localStorage.getItem('superAdmin') === "false" || (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0)){
            this.getRepairs();
        }

        this.props.getAllItemsIcons();


        this.SetHeaderButtons({
            tabValue: this.state.tabValue,
            repairSelectedForDetailsStatus: this.state.repairSelectedForDetailsStatus,
            repairsSelected: this.state.repairSelected,
        });
    };

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
        this.props.SetHeaderButtons(undefined);
    }

    SetHeaderButtons = (options) => {
        const headerButtons = this.getHeaderButtons(options);
        this.props.SetHeaderButtons(headerButtons)
    }

    getHeaderButtons = (options) => {
        const styles = {
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            },
        }

        return (
            <div style={styles.globalActions}>
                {
                    options.tabValue === 1 || (options.repairSelectedForDetailsStatus && options.repairSelectedForDetailsStatus === 'pending') ?
                        <Grid item className="appbtn-list-engage" style={{}}>
                            <>
                                <Grid item className="appbtn-engage redbtn-engage appbtnBarButton" style={{ width: '123px', borderRadius: '19px', marginRight: '15px', opacity: (options.repairsSelected && options.repairsSelected.length > 0)? '100%':'32%' }} 
                                onClick={
                                    () => {
                                        if (options.repairsSelected && options.repairsSelected.length > 0) {
                                            this.setState({ showModalCloseRepairs: true, isCancel: true });
                                        }
                                    }
                                }
                                    id='Repairs_cancel_btn'
                                >
                                    Cancel
                                </Grid>
                                <Grid item className="appbtn-engage greenbtn-engage appbtnBarButton" style={{ width: '160px', borderRadius: '19px', marginRight: '15px',  opacity: (options.repairsSelected && options.repairsSelected.length > 0)? '100%':'32%' }} 
                                onClick={
                                    () => {
                                        if (options.repairsSelected && options.repairsSelected.length > 0) {
                                            this.setState({ showModalCloseRepairs: true, isCancel:false })
                                        }
                                    }
                                }
                                id='Repairs_close_btn'
                                >
                                    Complete
                                </Grid>
                    
                                <Grid id='Repairs_Schedule_btn' item className="appbtn-engage skybluebtn-engage appbtnBarButton" style={{ width: '154px', borderRadius: '19px', marginRight: '15px',  opacity: (options.repairsSelected && options.repairsSelected.length > 0)? '100%':'32%' }}
                                 onClick={() => { this.OpenModalHandler() }}>
                                    Schedule
                                </Grid>
                                {
                                    (!this.state.openRepairDetails || this.state.openRepairDetails !== true)?
                                    <Grid id='Repairs_AddRepairrequest_btn' item className="appbtn-engage skybluebtn-engage appbtnBarButton" style={{ width: '280px', borderRadius: '19px', marginRight: '15px',  opacity: (!options.repairsSelected || options.repairsSelected.length === 0)? '100%':'32%', cursor: (!options.repairsSelected || options.repairsSelected.length === 0)? 'pointer':'not-allowed' }}
                                        onClick={ (!options.repairsSelected || options.repairsSelected.length === 0)? () => this.setState({showAddRepairView: true}) : undefined }
                                    >
                                        Add Repair Request
                                    </Grid>
                                    :
                                    undefined
                                }
                            </>

                        </Grid>
                        :
                        undefined
                }
            </div>
        )
    }


    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }

    getRepairs = async () => {
        this.props.getAllRepairs(localStorage.getItem('communityId'));
        await this.props.getHistoricDashboard(localStorage.getItem('communityId'));

        await this.getOpenScrollingRepair();
        await this.getCloseScrollingRepair();
    };

    getOpenScrollingRepair = async(page) => {
        let resOpenRequest = undefined;
        if(this.state.filtersOpenedApply){
            resOpenRequest = await this.GetRepairsWithFilters();
        }else{
            resOpenRequest= await this.props.getOpenRepairs(localStorage.getItem('communityId'), page);
        }

        return (resOpenRequest && resOpenRequest.ok)? true: false
    }
    getCloseScrollingRepair = async (page) => {

        let resCloseRequest = undefined;
        if(this.state.filtersClosedApply){
            resCloseRequest = await this.GetRepairsWithFilters();
        }else{
            resCloseRequest = await this.props.getCloseRepairs(localStorage.getItem('communityId'), page);
        }

        return (resCloseRequest && resCloseRequest.ok)? true: false
    }

    handleDeleteClick = (e, data, index) => {

        Alert.warning('Are you sure you want to delete work order?', {
            position: 'bottom-right',
            effect: 'slide',
            timeout: 10000,
            customFields: {
                displayComponent: true,
                handleButtonClick: this.deleteElemet,
                id: data,
            },
        });

    }

    deleteElemet = (event, item, isActive) => {

        if (item._id) {
            this.closeRepair(item);
        }
        // const lastPage = Math.ceil((this.props.tableData.length-1 )  / this.state.itemPerPage);

        Alert.closeAll();
    }

    CancelRepair = () => {
        var link = document.getElementById('cancel_btn')
        link.click()
    }

    SaveRepair = () => {
        var link = document.getElementById('save_btn')
        link.click()
    }

    editRepair = (e, item, index) => {
        this.setState({ repair: item, open: true });
    }

    handleClose = (pageNextIssue = 0) => {
        this.setState({ open: false, repair: {} });

        if (pageNextIssue > 0) {
            this.handlePageChange(pageNextIssue);
        }
    };

    handlePageChange = (number, status) => {
        if (number && typeof (number) == 'number' && number > 0) {
            if (status === 'pending') {

                this.setState({
                    currentPageOpended: Number(number)
                });
            }
            else {
                this.setState({
                    currentPageClosed: Number(number)
                });
            }
        }
    };

    closeRepair(item) {

        this.setState({ isRefreshedNeded: true });
        if (item.orderStatus !== 'completed') {
            item.orderStatus = 'completed';
            item.repairDate = new Date();

            this.props.closeRepair(item);
        }

        this.setState({ isRefreshedNeded: false });

    };

    GetCommunityObjectForSupuerUserCombo(communityId) {
        let communityObj = null;
        if (this.props.communityData) {

            communityObj = this.props.communityData.find(item => item.communityId === communityId);
        }

        return communityObj;
    };

    GetResponseTime = (createddate, repairDate) => {
        const cDate = new Date(createddate);
        const rDate = new Date(repairDate);

        let seconds = Math.floor(Math.abs(cDate - rDate) / 1000);
        let days = 0;
        let hours = 0;
        let minutes = 0;

        let repairTimeString = '';

        if (seconds >= 86400) {
            days = Math.floor(seconds / 86400);
            seconds = seconds - (86400 * days);
            repairTimeString = days + ' d ';
        }

        if (seconds >= 3600) {
            hours = Math.floor(seconds / 3600);
            seconds = seconds - (hours * 3600);
            repairTimeString += hours + ' hr ';
        }

        if (seconds >= 60) {
            minutes = Math.floor(seconds / 60);
            seconds = seconds - (minutes * 60);

            repairTimeString += minutes + ' min ';
        }

        if (repairTimeString === '') {
            repairTimeString = '< 1 min';
        }

        return repairTimeString;
    };

    reScheduleAllRepairs = (FiveMinutesBeforeDate) => {
        const repairsToReSchedule = [];
        const repairs = this.props.tableData ? this.props.tableData : [];

        if (repairs && repairs.length > 0) {
            repairs.filter(item => item.orderStatus === 'pending').forEach(
                repair => {

                    const repairScheduleDateObject = (repair && repair.timeLine) ? repair.timeLine.find(action => action.title === 'Scheduled Date') : undefined;
                    const repairScheduleDate = repairScheduleDateObject ? moment(repairScheduleDateObject.timeLineDate) : undefined;


                    if (repairScheduleDate && (repairScheduleDate < FiveMinutesBeforeDate)) {
                        repairsToReSchedule.push(repair);
                    }
                }
            );
        }


        if (repairsToReSchedule && repairsToReSchedule.length > 0) {
            this.setState({ repairsSelected: repairsToReSchedule });
            this.SetHeaderButtons({
                tabValue: this.state.tabValue,
                repairSelectedForDetailsStatus: this.state.repairSelectedForDetailsStatus,
                repairsSelected: repairsToReSchedule,
            });

            setTimeout(() => {

                this.ScheduleRepairHandler(FiveMinutesBeforeDate.add(5, 'minutes'), false);
                this.setState({ repairsSelected: undefined });

                this.SetHeaderButtons({
                    tabValue: this.state.tabValue,
                    repairSelectedForDetailsStatus: this.state.repairSelectedForDetailsStatus,
                    repairsSelected: undefined,
                });

                if (localStorage.getItem('superAdmin') === "false")
                    this.getRepairs();
            }, 50);

        }



    };


    handleChangeIndex = (index) => {
        this.setState({ tabValue: index, currentPageOpended:0, currentPageClosed:0 },()=>{


        this.SetHeaderButtons({
            tabValue: index,
            repairSelectedForDetailsStatus: this.state.repairSelectedForDetailsStatus,
            repairsSelected: this.state.repairSelected,
        });

        switch (index) { //call again the api to get the newest info
            case 0:
                this.props.getHistoricDashboard(localStorage.getItem('communityId'));
                document.title='Repairs - Dashboard'
                break;
            case 1:
                this.getOpenScrollingRepair();
                document.title='Repairs - Opened'
                break;
            case 2:
                this.getCloseScrollingRepair();
                document.title='Repairs - Completed'

                break;
        
            default:
                break;
        }

        });

    };

    handleTabChange = (event, newValue) => {
        this.setState({repairsSelected: [], searchOpenedValue:undefined, searchClosedValue:undefined, openSearchOpened:false, openSearchClosed:false})
        this.handleChangeIndex(newValue);
    };

    a11yProps = (index) => {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    };

    //#endregion

    //#region Handlers
    ToogleCheckBoxHandler = (repair) => {
        if (this.state.repairsSelected) {
            const arrayRepairsSelected = this.state.repairsSelected;

            const item = arrayRepairsSelected.find(item => item._id === repair._id);

            if (!item) {
                arrayRepairsSelected.push(repair);
            }
            else {
                const indexToDelete = arrayRepairsSelected.map(item => item._id).indexOf(repair._id);

                arrayRepairsSelected.splice(indexToDelete, 1);
            }

            this.setState({ repairsSelected: arrayRepairsSelected });
            this.SetHeaderButtons({
                tabValue: this.state.tabValue,
                repairSelectedForDetailsStatus: this.state.repairSelectedForDetailsStatus,
                repairsSelected: arrayRepairsSelected,
            });
        }
    };

    SelectAllRepaisHandler = () => {
        const selectAllButton = !this.state.selectAllButton;
        let arrayRepairsSelected = this.state.repairsSelected ? this.state.repairsSelected : [];

        let repairsPending = this.props.repairTableData.openS.length > 0 ? this.props.repairTableData.openS : 0;

        if (repairsPending.length > arrayRepairsSelected.length) {
            if (this.props.tableData.length > 0) {
                repairsPending.forEach(item => {
                    const indexOfItemAllReadySelected = (this.state.repairsSelected) ? this.state.repairsSelected.map(item => item._id).indexOf(item._id) : -1;

                    if (indexOfItemAllReadySelected === -1) {

                        arrayRepairsSelected.push(item);
                    }
                }
                );
            }
        }
        else {
            if (this.props.tableData.length > 0) {
                repairsPending.forEach(item => {
                    if (this.state.repairsSelected) {
                        const indexToDelete = this.state.repairsSelected.map(item => item._id).indexOf(item._id);

                        if (indexToDelete !== -1) {

                            arrayRepairsSelected.splice(indexToDelete, 1);
                        }
                    }
                });
            }
        }

        this.setState({ repairsSelected: arrayRepairsSelected, selectAllButton: selectAllButton });
        this.SetHeaderButtons({
            tabValue: this.state.tabValue,
            repairSelectedForDetailsStatus: this.state.repairSelectedForDetailsStatus,
            repairsSelected: arrayRepairsSelected,
        });
    };

    SelectOptionForRepair = (scheduleDate, option) => {

        let hour = scheduleDate.hour() > 12 ? scheduleDate.hour() - 12 : scheduleDate.hour();
        let minute = scheduleDate.minutes();
        let dayTime = scheduleDate.hour() > 11 ? 'PM' : 'AM';
        let daySelected = scheduleDate.clone().startOf('day');

        if (this.state.fixedOptionSelected && this.state.fixedOptionSelected === option) {
            option = undefined;
            hour = undefined;
            minute = undefined;
            dayTime = undefined;
            daySelected = undefined;
        };

        let hourObject = {
            number: undefined,
            text: '',
        }

        let minuteObject = {
            number: undefined,
            text: '',
        }

        const datTimeObject = {
            text: dayTime,
        }


        if (hour === undefined) {
            hourObject = {
                number: undefined,
                text: '',
            }
        } else {

            hourObject = {
                number: hour,
                text: ('0' + hour).slice(-2),
            }
        }

        if (minute === undefined) {
            minuteObject = {
                number: undefined,
                text: '',
            }
        } else {

            minuteObject = {
                number: minute,
                text: ('0' + minute).slice(-2),
            }
        }


        this.setState({
            fixedOptionSelected: option,
            hourSelected: hourObject,
            minuteSelected: minuteObject,
            dayTime: datTimeObject,
            scheduleDay: daySelected,
        });


    }

    ScheduleRepairHandler = (scheduleDate, showAlerts = true) => {


        const scheduleRepairDate = new Date(scheduleDate);
        const ArrayRepairs = this.state.repairsSelected ? this.state.repairsSelected : [];
        const profileKeyCloakObj = localStorage.getItem('ky') ? JSON.parse(localStorage.getItem('ky')) : undefined;
        let profileObject = (profileKeyCloakObj && profileKeyCloakObj.profile) ? profileKeyCloakObj.profile : undefined;
        let username = (profileObject && profileObject.username) ? profileObject.username : undefined;


        let scheduleObject = {
            userName: username,
            scheduleDate: scheduleRepairDate ? scheduleRepairDate : undefined
        };




        if (scheduleRepairDate) {

            if (ArrayRepairs) {
                ArrayRepairs.forEach(
                    item => {

                        if (scheduleObject && scheduleObject.userName && scheduleObject.scheduleDate) {
                            this.props.ScheduleWorkOrder(item._id, item, scheduleObject, showAlerts)
                        }
                    });
            }
        }



    };

    MakeRepairDate() {

        if (this.state.scheduleDay === undefined || this.state.dayTime === undefined || this.state.minuteSelected === undefined || this.state.hourSelected === undefined)
            return


        const now = moment(new Date()).startOf('minute');
        let repairDate = moment(new Date());

        if (this.state.scheduleDay && this.state.hourSelected && this.state.minuteSelected && this.state.dayTime) {

            repairDate = moment(this.state.scheduleDay.format('MM-DD-YYYY') + ' ' + this.state.hourSelected.number + ':' + this.state.minuteSelected.number + ' ' + this.state.dayTime.text, 'MM-DD-YYYY hh:mm A');

        }

        if (repairDate < now) {
            let nowHour = now.hour() > 12 ? now.hour() - 12 : now.hour();
            let nowMinute = now.minutes();
            let nowDayTime = now.hour() > 11 ? 'PM' : 'AM';
            let nowDay = now.clone().startOf('day');


            let hourObject = {
                number: undefined,
                text: '',
            }

            let minuteObject = {
                number: undefined,
                text: '',
            }

            const datTimeObject = {
                text: nowDayTime,
            }


            if (nowHour === undefined) {
                hourObject = {
                    number: undefined,
                    text: '',
                }
            } else {

                hourObject = {
                    number: nowHour,
                    text: ('0' + nowHour).slice(-2),
                }
            }

            if (nowMinute === undefined) {
                minuteObject = {
                    number: undefined,
                    text: '',
                }
            } else {

                minuteObject = {
                    number: nowMinute,
                    text: ('0' + nowMinute).slice(-2),
                }
            }



            this.setState({
                hourSelected: hourObject,
                minuteSelected: minuteObject,
                dayTime: datTimeObject,
                scheduleDay: nowDay,
            });


            const message = `Cannot select a time in the past`

            sweetAlert('error', message, 'alert_RepairsV2_PastTime_Error');

        } else {

            if (repairDate &&
                this.state.hourSelected &&
                this.state.minuteSelected &&
                this.state.dayTime &&
                this.state.scheduleDay) {

                this.ScheduleRepairHandler(repairDate);
                this.CleanScheduleModal();
                if (this.state.openRepairDetails === false) {
                    this.setState({ repairsSelected: [] });

                    this.SetHeaderButtons({
                        tabValue: this.state.tabValue,
                        repairSelectedForDetailsStatus: this.state.repairSelectedForDetailsStatus,
                        repairsSelected: [],
                    });

                }

                if (localStorage.getItem('superAdmin') === "false" || (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0)) {
                    setTimeout(() => {
                        this.getRepairs();
                    }, 200);

                    if (this.state.openRepairDetails === true && this.state.repairSelectedForDetails) {
                        setTimeout(() => {

                            const idRepairSelected = this.state.repairSelectedForDetails._id;
                            const repairWithSelectedRepairId = this.props.tableData.find(repair => repair._id === idRepairSelected);

                            if (repairWithSelectedRepairId) {
                                this.setState({ openRepairDetails: false });

                                this.setState({ repairSelectedForDetails: { ...repairWithSelectedRepairId }, openRepairDetails: true });

                            }

                        }, 300);

                    }
                }

            } else {
                const message = `Please indicate a day and time to schedule the order`

                sweetAlert('error', message, 'alert_RepairsV2_NoYimeSelected_Error');
            }
        }


    };


    CleanScheduleModal = () => {

        this.setState({
            showScheduleRepairModal: false,
            scheduleDay: undefined,
            hourSelected: undefined,
            minuteSelected: undefined,
            dayTime: undefined,
            fixedOptionSelected: undefined,
            repairsSelected:[]
        })
    };

    CleanCloseRepairsModal = () => {

        this.setState({
            showModalCloseRepairs: false,

        })
    };



    OpenModalHandler = () => {
        if (this.state.repairsSelected && this.state.repairsSelected.length > 0) {

            this.setState({ showScheduleRepairModal: true });
        }
        else {
            return;
            // const message = 'please select at least 1 work order'
            // sweetAlert('error', message, 'alert_RepairsV2_NoWorkOrderSelected_Error');
        }

    };

    OnCancelHandler = () => {
        this.CleanCloseRepairsModal();
        this.setState({ isCancel: false });
    };

    OnCloseHandler = () => {
        let arrayOfRepairsToClose = this.state.repairsSelected ? this.state.repairsSelected : []

        const profileKeyCloakObj = localStorage.getItem('ky') ? JSON.parse(localStorage.getItem('ky')) : undefined;
        let profileObject = (profileKeyCloakObj && profileKeyCloakObj.profile) ? profileKeyCloakObj.profile : undefined;
        let closedByName = (profileObject && profileObject.username) ? profileObject.username : undefined;


        arrayOfRepairsToClose = arrayOfRepairsToClose.map(repair => {
            return { _id: repair._id, userName: closedByName }
        }
        );

        if (arrayOfRepairsToClose) {
            this.props.CloseRepairs(arrayOfRepairsToClose);
        }

        this.CleanCloseRepairsModal();

        setTimeout(() => {
            if (localStorage.getItem('superAdmin') === "false" || (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0))
                this.getRepairs();

            this.setState({ repairsSelected: [], openRepairDetails: false });
            this.SetHeaderButtons({
                tabValue: this.state.tabValue,
                repairSelectedForDetailsStatus: this.state.repairSelectedForDetailsStatus,
                repairsSelected: [],
            });

        }, 600);
    };

    OnCancelRepairs = () => {

        let arrayOfRepairsToCancel = this.state.repairsSelected ? this.state.repairsSelected : []
        arrayOfRepairsToCancel = arrayOfRepairsToCancel.map(repair => {
            return { _id: repair._id }
        }
        );

        if (arrayOfRepairsToCancel) {
            this.props.CancelRepairs(arrayOfRepairsToCancel);
        }

        this.CleanCloseRepairsModal();

        setTimeout(() => {
            if (localStorage.getItem('superAdmin') === "false" || (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0))
                this.getRepairs();

            this.setState({ repairsSelected: [], openRepairDetails: false });

            this.SetHeaderButtons({
                tabValue: this.state.tabValue,
                repairSelectedForDetailsStatus: this.state.repairSelectedForDetailsStatus,
                repairsSelected: [],
            });

        }, 600);
    }


    getAllRepairsOnAddView = () =>{
        try{

            if(!this.props.getAllRepairs)
                return undefined
            setTimeout(() => {
                this.props.getAllRepairs(localStorage.getItem('communityId'));
            }, 600);
        }catch(err){
            return undefined
        }
    }
    //#endregion

    handleDayClick = (day, today) => {

        if (day >= today) { this.setState({ scheduleDay: day }) }

        if (this.state.fixedOptionSelected !== undefined) {

            setTimeout(() => {

                const daySelected = moment(this.state.scheduleDay).format('DDDD');
                const todayD = moment(today).format('DDDD');
                const Tomorrow = moment(today).add(1, 'day').format('DDDD');

                if ((this.state.fixedOptionSelected === 1 || this.state.fixedOptionSelected === 2) && daySelected !== todayD) {

                    this.setState({ fixedOptionSelected: undefined });

                }
                else if (this.state.fixedOptionSelected === 3 && daySelected !== Tomorrow) {

                    this.setState({ fixedOptionSelected: undefined });

                }
            }, 300);
        }
    }

    handleCommunityCombo = () => {
        this.setState((prevState) => ({ openCommunityCombo: !prevState.openCommunityCombo }));
    }
    handleCommunityOnBlur = () => {
        this.setState({ openCommunityCombo: false })
    }

    AddStep = (step) => {

        let newValue = this.state.stepCounter + step;
        this.setState({ stepCounter: newValue });

        if (newValue === 1)
            this.setState({ disabledBackIcon: false, disabledFowardIcon: true });
        else
            this.setState({ disabledBackIcon: true, disabledFowardIcon: false });
    }

    onChangeHandler = (e, placeholder) => {

        let timeValue = e.target.value.slice(-2)

        if (placeholder === 'hr') {
            if ((!Number.isInteger(Number(e.target.value))) || (Number(timeValue) > 12)) {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                let hour = 0;

                hourObject.number = hour;
                hourObject.text = ('0' + hour).slice(-2);

                this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
            } else {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                let hour = Number(e.target.value);

                hourObject.number = hour;
                hourObject.text = ('0' + hour).slice(-2);

                this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
            }
        }

        if (placeholder === 'min') {
            if ((!Number.isInteger(Number(e.target.value))) || (Number(timeValue) > 59)) {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                let minute = 0;

                minuteObject.number = minute
                minuteObject.text = ('0' + minute).slice(-2);

                this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
            } else {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                let minute = Number(e.target.value.slice(-2));

                minuteObject.number = minute
                minuteObject.text = ('0' + minute).slice(-2);

                this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
            }
        }

        if (placeholder === 'AM') {
            if (!(e.target.value === 'AM' || e.target.value === 'PM')) {
                this.setState({ dayTime: { text: 'AM' }, fixedOptionSelected: undefined });
            }
        }
    }


    setIdsPaginationHandler = () => {
        try {
            const pagContainer = document.getElementsByClassName('MuiPagination-ul');
            if (pagContainer && pagContainer.length > 0 && pagContainer[0]) {
                const pag = pagContainer[0];
                const liElements = pag.getElementsByTagName('li');
                if (liElements && liElements.length >= 4) {
                    for (let i = 0; i < liElements.length; i++) {
                        liElements[i].removeAttribute('id')
                    }
                    const btn_GoToFist = liElements[0];
                    if (btn_GoToFist) {
                        btn_GoToFist.setAttribute('id', 'pag_btn_gotofirst');
                        btn_GoToFist.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_back = liElements[1];
                    if (btn_back) {
                        btn_back.setAttribute('id', 'pag_btn_goback');
                        btn_back.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_forward = liElements[liElements.length - 2];
                    if (btn_forward) {
                        btn_forward.setAttribute('id', 'pag_btn_goforward');
                        btn_forward.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_GoToLast = liElements[liElements.length - 1];
                    if (btn_GoToLast) {
                        btn_GoToLast.setAttribute('id', 'pag_btn_gotolast');
                        btn_GoToLast.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }

                    for (let i = 2; i < liElements.length - 2; i++) {
                        const btn = liElements[i].getElementsByTagName('button');

                        if (btn && btn.length > 0 && btn[0] && btn[0].textContent.length > 0) {
                            liElements[i].setAttribute('id', `pagElement_${btn[0].textContent}`);
                        }
                    }
                }
            }
        } catch (err) { }
    }

    localStorageRemoveItem = (key) => {
        try {
            if (key) {
                localStorage.removeItem(key);
            }

            this.setState({
                currentPageClosed: 0,
                currentPageOpended: 0,
            })

        } catch (err) { }
    };

    localStorageSetItem = (key, value) => {
        try {
            if (key && value) {
                localStorage.setItem(key, value);
            }

            this.setState({
                currentPageClosed: 0,
                currentPageOpended: 0,
                filtersClosedApply: false,
                filtersOpenedApply:false, 
                filtersOpenedObj: {...initFilters, statusSelected:[], itemsSelected:[], issuesSelected:[]},
                filtersClosedObj:{...initFilters, statusSelected:[], itemsSelected:[], issuesSelected:[]},
                repairsSelected:[],
                selectAllButton:[],
                sortOpenedColumn:'createdDate',
                sortOpenedDesc:false,
                sortClosedColumn:'createdDate',
                sortClosedDesc:false
            })
        } catch (err) { }  
    };

    setLocalState = (objectToSet) => {
        try {
            this.setState({ ...objectToSet })
        } catch (err) { }
    };

    async GetRepairsWithFilters(){
        this.SetHeaderButtons({
            tabValue: this.state.tabValue,
            repairSelectedForDetailsStatus: undefined,
            repairsSelected: [],
        });

        const id = localStorage.getItem('communityId');
        const page = this.state.tabValue === 1 ? this.state.currentPageOpended : this.state.currentPageClosed
        const objFilters = this.state.tabValue === 1 ?this.state.filtersOpenedObj : this.state.filtersClosedObj
        const searchValue = this.state.tabValue===1? this.state.searchOpenedValue : this.state.tabValue===2? this.state.searchClosedValue : ''
        const sort = this.state.tabValue===1? this.state.sortOpenedColumn : this.state.tabValue===2? this.state.sortClosedColumn : 'createdDate'
        const sortDirection = this.state.tabValue===1? this.state.sortOpenedDesc : this.state.tabValue===2? this.state.sortClosedDesc : true

        const res = await this.props.GetRepairsFilters(id, this.state.tabValue, objFilters, page, searchValue, sort, sortDirection );
        return res
    }

    applyFilters = (filters) => {
        if(this.state.tabValue===1){

            this.setState({ filtersOpenedObj: filters, currentPageOpended: 0, filtersOpenedApply: true, selectAllButton:false, repairsSelected:[] }, ()=>this.GetRepairsWithFilters());

        }else if(this.state.tabValue===2){

            this.setState({ filtersClosedObj: filters, currentPageClosed: 0, filtersClosedApply: true }, ()=>this.GetRepairsWithFilters());
        }
    }

    resetFilters = () => {
        if(this.state.tabValue===1){

            if(this.state.sortOpenedColumn==='createdDate' && this.state.sortOpenedDesc===false){ //No sort applied
                this.setState({ 
                    filtersOpenedObj: {...initFilters, itemsSelected:[], statusSelected:[], issuesSelected:[]}, 
                    currentPageOpended: 0, 
                    filtersOpenedApply: false, 
                    openSearchOpened:false, 
                    searchOpenedValue:'' 
                }, ()=>this.getOpenScrollingRepair());
            }else{
                this.setState({ 
                    filtersOpenedObj: {...initFilters, itemsSelected:[], statusSelected:[], issuesSelected:[]}, 
                    currentPageOpended: 0, 
                    filtersOpenedApply: true, 
                    openSearchOpened:false, 
                    searchOpenedValue:'' 
                },()=>this.GetRepairsWithFilters());
            }
            
          

        }else if(this.state.tabValue===2){


            if(this.state.sortClosedColumn ==='createdDate' && this.state.sortClosedDesc === false){ //No sort applied
                this.setState({ 
                    filtersClosedObj: {...initFilters, itemsSelected:[], statusSelected:[], issuesSelected:[]}, 
                    currentPageClosed: 0,
                    filtersClosedApply: false,
                    searchClosedValue:'',
                    openSearchClosed:false
                }, ()=>this.getCloseScrollingRepair() );
            }else{
                this.setState({ 
                    filtersClosedObj: {...initFilters, itemsSelected:[], statusSelected:[], issuesSelected:[]}, 
                    currentPageClosed: 0, 
                    filtersClosedApply: true, 
                    openSearchClosed:false, 
                    searchClosedValue:'' 
                },()=>this.GetRepairsWithFilters());
            }

           

        }

    }

    handleSearch = () => {
        if(this.state.tabValue===1){
            this.setState({ filtersOpenedApply: true, currentPageOpended: 0 }, () => this.GetRepairsWithFilters());

        }else if(this.state.tabValue===2){
            this.setState({ filtersClosedApply: true, currentPageClosed: 0 }, () => this.GetRepairsWithFilters());

        }
    }

    handleResetSearch = () => {
        if(this.state.tabValue===1){
            this.setState({ searchOpenedValue:'', openSearchOpened: false, currentPageOpended: 0 }, () => this.GetRepairsWithFilters());

        }else if(this.state.tabValue===2){
            this.setState({ searchClosedValue:'', openSearchClosed: false, currentPageClosed: 0 }, () => this.GetRepairsWithFilters());
        }
    }

    handleSort = (column) => {

        if(this.state.tabValue===1){

            const currentColumn = this.state.sortOpenedColumn;

            const updState = {
                sortOpenedColumn: currentColumn,
                sortOpenedDesc: this.state.sortOpenedDesc,
                currentPageOpended: 0,
                filtersOpenedApply: true,
                stillClose: true,
                stillOpen: true
            }
    
            if(currentColumn!==column){
                updState.sortOpenedColumn = column
                updState.sortOpenedDesc = true;
            }else{
                updState.sortOpenedDesc = !this.state.sortOpenedDesc
            }

            this.setState(updState, ()=>this.GetRepairsWithFilters())
       
        }else if(this.state.tabValue===2){

            const currentColumn = this.state.sortClosedColumn;
           
            const updState = {
                sortClosedColumn: currentColumn,
                sortClosedDesc: this.state.sortClosedDesc,
                currentPageClosed: 0,
                filtersClosedApply: true
            }
    
            if(currentColumn!==column){
                updState.sortClosedColumn = column
                updState.sortClosedDesc = true;
            }else{
                updState.sortClosedDesc = !this.state.sortClosedDesc
            }
    
            this.setState(updState, ()=>this.GetRepairsWithFilters())
        }
     

    }


    
    CancelAddRequestHandler = async () =>{
        this.SetHeaderButtons({
            tabValue: this.state.tabValue,
            repairSelectedForDetailsStatus: this.state.repairSelectedForDetailsStatus,
            repairsSelected: this.state.repairSelected,
        });
        this.setState({tabValue: 1, showAddRepairView: false})
        await this.getRepairs()
    }


    //#region Inner Components
    RenderAppBar = () => {
        const isSuperAdmin = localStorage.getItem('superAdmin') ? (localStorage.getItem('superAdmin') === "true") : false;

        if (isSuperAdmin
            && this.props.communityData
            && this.props.communityData.length > 0
            && localStorage.getItem('communityId')
            && localStorage.getItem('communityId').length > 0
            && this.state.superUserCommunitySelected === undefined
        ) {
            this.setState({ superUserCommunitySelected: this.GetCommunityObjectForSupuerUserCombo(localStorage.getItem('communityId')) });
        }

        return (
            <AppBar position="static" className="dark">
                <Toolbar>
                    <Grid container alignItems='center' style={{ height: '100%' }}>
                        <Grid item container xs={4}>
                            {
                                (!this.state.openRepairDetails || (this.state.openRepairDetails && this.state.openRepairDetails === false)) ?
                                    <Typography variant="h6" >
                                        <span className="titleAppBar">
                                            Repairs
                                        </span>
                                    </Typography>
                                    :
                                    <Typography variant="h6" >
                                        <Grid item container xs={12} className="engage-nav" id='Repairs_back_btn' onClick={() => {
                                            this.setState({
                                                openRepairDetails: false,
                                                repairsSelected: [],
                                                repairSelectedForDetails: undefined,
                                                repairSelectedForDetailsStatus: undefined,
                                                currentPageOpended:0,
                                                currentPageClosed:0
                                            },
                                                () => {
                                                    this.SetHeaderButtons({
                                                        tabValue: this.state.tabValue,
                                                        repairSelectedForDetailsStatus: undefined,
                                                        repairsSelected: [],
                                                    });
                                                    this.getRepairs();
                                                }
                                            );

                                        }}>
                                            <Grid item xs={4}>
                                                <img
                                                    src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                    alt='return'
                                                    className="AppbarBackIcon"
                                                />
                                            </Grid>
                                            <Grid item xs={8} className="AppBarRepairsBackButton">
                                                {
                                                    (this.state.repairSelectedForDetailsStatus && this.state.repairSelectedForDetailsStatus === 'pending') ? 'Opened'
                                                        :
                                                        (this.state.repairSelectedForDetailsStatus && (this.state.repairSelectedForDetailsStatus === 'completed' || this.state.repairSelectedForDetailsStatus === 'canceled')) ? 'Closed'
                                                            :
                                                            'Repairs'
                                                }
                                            </Grid>
                                        </Grid>
                                    </Typography>
                            }

                        </Grid>
                        <Grid item container xs={8} justify='flex-end' style={{}}>
                            {/* Super User combo */}
                            <Grid item container justify='flex-end' alignContent="center" xs={12} sm={10} md={6} lg={6}>
                                {
                                    (!this.state.openRepairDetails && (isSuperAdmin && isSuperAdmin === true)) ?
                                        <Grid item container xs={10} style={{ paddingLeft: '15px' }} justify='center' alignContent='center' >
                                            <SuperUserDropDown
                                                stateOpen={this.state.open}
                                                localStorageSetItem={this.localStorageSetItem}
                                                localStorageRemoveItem={this.localStorageRemoveItem}
                                                SetHeaderButtons={this.SetHeaderButtons}
                                                handleCommunityCombo={this.handleCommunityCombo}
                                                setState={this.setLocalState}
                                                communityData={this.props.communityData}
                                                superUserCommunitySelected={this.state.superUserCommunitySelected}
                                                openCommunityCombo={this.state.openCommunityCombo}
                                                handleCommunityOnBlur={this.handleCommunityOnBlur}
                                            />
                                        </Grid>
                                        :
                                        undefined

                                }
                            </Grid>
                            {/* {
                            (!this.state.openRepairDetails && (isSuperAdmin && isSuperAdmin === true))?
                            <Grid item  xs={4}  style={{paddingLeft:'15px', marginRight:'15px', height:'39px',}} justify='center' onClick={this.handleCommunityCombo}>
                                <SimpleSelect
                                    label={'Community'}
                                    onChangeHandler = {(evet, newItem) => {if(newItem !== null && newItem !== ''){
                                         localStorage.setItem('communityId',newItem.communityId);  
                                         this.setState({superUserCommunitySelected: newItem, repairsSelected:[]});
                                         this.SetHeaderButtons({
                                            tabValue:this.state.tabValue,
                                            repairSelectedForDetailsStatus:this.state.repairSelectedForDetailsStatus,
                                            repairsSelected: [], 
                                        });
                                    } }}
                                    optionsItemsIconsData = {this.props.communityData? this.props.communityData : []}
                                    selected = {this.state.superUserCommunitySelected? this.state.superUserCommunitySelected :{}}
                                    disabled= {false}
                                    open={this.state.openCommunityCombo}
                                    onBlur={this.handleCommunityOnBlur}
                                />
                            </Grid>                                                    
                            : 
                            undefined          
                        } */}

                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        )
    };

    RenderTabsFullContent = () =>{
        const currentDataOpen = this.props.currentDataOpen ? this.props.currentDataOpen  : [];
        const currentDataClose = this.props.currentDataClose ? this.props.currentDataClose : [];

        const repairSelected = this.state.repairSelectedForDetails ? this.state.repairSelectedForDetails : undefined;

        return(
            <>
                <this.RenderAppBar />
                {
                    (!this.state.openRepairDetails || this.state.openRepairDetails !== true) ?
                        <Grid container >
                            {/* Tabs Names Bar */}
                            <AppBar position="static" color="default" elevation={0} classes={{ root: 'Activity10' }} style={{ backgroundColor: '#2a2a2b' }}>
                                <Tabs
                                    value={this.state.tabValue}
                                    onChange={this.handleTabChange}

                                    TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                    variant="fullWidth"
                                    aria-label="full width tabs community"
                                    className="tabsStyle"
                                >
                                    <Tab id='Repairs_tab_dashboard' label="Dashboard" className={(this.state.tabValue === 0) ? "SelectedTabStyle" : "tabStyle"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                                    <Tab id='Repairs_tab_opened' label="Opened" className={(this.state.tabValue === 1) ? "SelectedTabStyle" : "tabStyle"} {...this.a11yProps(1)} disableRipple={true} disableFocusRipple={true} />
                                    <Tab id='Repairs_tab_closed' label="Completed" className={(this.state.tabValue === 2) ? "SelectedTabStyle" : "tabStyle"} {...this.a11yProps(2)} disableRipple={true} disableFocusRipple={true} />
                                </Tabs>
                            </AppBar>
                            <SwipeableViews
                                axis={'x'}
                                index={this.state.tabValue}
                                onChangeIndex={this.handleChangeIndex}
                                className="swipeableViews"
                            >
                                {/* Dashboard */}
                                <TabPanel value={this.state.tabValue} index={0} dir={'x'}  >
                                    <RepairsDashboard repairs={this.props.tableData ? this.props.tableData : undefined} />
                                </TabPanel>
                                {/* Opened */}
                                <TabPanel value={this.state.tabValue} index={1} dir={'x'}>
                                    <Grid item container xs={12} className="RenderRepairsStyles">
                                        {/* Search and filters menu */}
                                        <Grid item container xs={12} justifyContent='flex-end' alignItems='center'>
                                            {
                                                this.state.openSearchOpened ?
                                                <Grid item container xs={10} sm={10} md={6} lg={4} style={{ marginBottom: '1rem' }}>
                                                    <TextField
                                                        id='opened_repairs_search'
                                                        item
                                                        name='Search'
                                                        placeholder="Enter search term(s) and press Enter"
                                                        value={this.state.searchOpenedValue}
                                                        fullWidth
                                                        InputProps={{
                                                            disableUnderline: true,
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <img
                                                                        src='https://engage360.s3.amazonaws.com/Icons/Categories/search.svg'
                                                                        alt='search_icon'
                                                                        width='32px'
                                                                        height='32px'
                                                                    />
                                                                </InputAdornment>
                                                            ),
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton id='activities_clear_btn' onClick={this.handleResetSearch}>
                                                                        <FontAwesomeIcon icon={faTimesCircle} color='white' size='sm' />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                        className="activities_search animate__animated animate__slideInRight"
                                                        onChange={(e) => this.setState({ searchOpenedValue: e.target.value })}
                                                        onKeyDown={ (e) => {
                                                            return (e && e.keyCode === 13)? this.handleSearch(): undefined
                                                        }}
                                                    />

                                                </Grid>
                                                :
                                                <IconButton item onClick={() => this.setState({ openSearchOpened: true })} id='search_opened_btn'>
                                                    <img
                                                        src='https://engage360.s3.amazonaws.com/Icons/Categories/search.svg'
                                                        alt='search_icon'
                                                        width='30px'
                                                        height='30px'
                                                    />
                                                </IconButton>
                                            }

                                        

                                                        

                                            <IconButton 
                                                item 
                                                onClick={(e) => {
                                                    this.setState({ filtersOpenedAnchorEl: e.currentTarget })
                                                }}
                                                id='filters_btn' 
                                            >
                                                <img
                                                    src='https://engage360.s3.amazonaws.com/Icons/Categories/filter.svg'
                                                    alt='filters_icon'
                                                    width='30px'
                                                    height='30px'
                                                />
                                            </IconButton>

                                        </Grid>
                                        
                                        {/* Titles Repairs  List*/}
                                        <Grid item container xs={12} justify='center' alignItems='center'>

                                            <Grid item xs={1} className="RepairsRowTitle">
                                                <Button id='Repairs_select_all_btn' className="selectAllButton" onClick={() => this.SelectAllRepaisHandler()}>
                                                    Select All
                                                </Button>                                                
                                            </Grid>

                                            <Grid item xs={2} className="RepairsRowTitle">
                                                Resident
                                                <IconButton onClick={()=>this.handleSort('resident.lastName')}>
                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortOpenedColumn==='resident.lastName' && this.state.sortOpenedDesc)? 
                                                        faSortAlphaDown 
                                                        : 
                                                        (this.state.sortOpenedColumn==='resident.lastName' && !this.state.sortOpenedDesc)? 
                                                        faSortAlphaUpAlt 
                                                        : 
                                                        (this.state.sortOpenedColumn!=='resident.lastName')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={2} className="RepairsRowTitle">
                                                Location
                                                <IconButton onClick={()=>this.handleSort('resident.zoneName')}>
                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortOpenedColumn==='resident.zoneName' && this.state.sortOpenedDesc)? 
                                                        faSortAlphaDown 
                                                        : 
                                                        (this.state.sortOpenedColumn==='resident.zoneName' && !this.state.sortOpenedDesc)? 
                                                        faSortAlphaUpAlt 
                                                        : 
                                                        (this.state.sortOpenedColumn!=='resident.zoneName')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={1} className="RepairsRowTitle">
                                                Room
                                                <IconButton onClick={()=>this.handleSort('room.name')}>
                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortOpenedColumn==='room.name' && this.state.sortOpenedDesc)? 
                                                        faSortAlphaDown 
                                                        : 
                                                        (this.state.sortOpenedColumn==='room.name' && !this.state.sortOpenedDesc)? 
                                                        faSortAlphaUpAlt 
                                                        : 
                                                        (this.state.sortOpenedColumn!=='room.name')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={1} className="RepairsRowTitle">
                                                Item
                                                <IconButton onClick={()=>this.handleSort('item.name')}>
                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortOpenedColumn==='item.name' && this.state.sortOpenedDesc)? 
                                                        faSortAlphaDown 
                                                        : 
                                                        (this.state.sortOpenedColumn==='item.name' && !this.state.sortOpenedDesc)? 
                                                        faSortAlphaUpAlt 
                                                        : 
                                                        (this.state.sortOpenedColumn!=='item.name')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>

                                            </Grid>
                                            <Grid item xs={1} className="RepairsRowTitle">
                                                Issue
                                                <IconButton onClick={()=>this.handleSort('issue.name')}>

                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortOpenedColumn==='issue.name' && this.state.sortOpenedDesc)? 
                                                        faSortAlphaDown 
                                                        : 
                                                        (this.state.sortOpenedColumn==='issue.name' && !this.state.sortOpenedDesc)? 
                                                        faSortAlphaUpAlt 
                                                        : 
                                                        (this.state.sortOpenedColumn!=='issue.name')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>

                                            </Grid>
                                            <Grid item xs={2} className="RepairsRowTitle">
                                                Status
                                                <IconButton onClick={()=>this.handleSort('orderStatus')}>
                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortOpenedColumn==='orderStatus' && this.state.sortOpenedDesc)? 
                                                        faSortAlphaDown 
                                                        : 
                                                        (this.state.sortOpenedColumn==='orderStatus' && !this.state.sortOpenedDesc)? 
                                                        faSortAlphaUpAlt 
                                                        : 
                                                        (this.state.sortOpenedColumn!=='orderStatus')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>

                                            </Grid>
                                            <Grid item xs={2} className="RepairsRowTitle">
                                                Date Submitted
                                                <IconButton onClick={()=>this.handleSort('createdDate')}>
                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortOpenedColumn==='createdDate' && this.state.sortOpenedDesc)? 
                                                        faSortNumericDown 
                                                        : 
                                                        (this.state.sortOpenedColumn==='createdDate' && !this.state.sortOpenedDesc)? 
                                                        faSortNumericUpAlt 
                                                        : 
                                                        (this.state.sortOpenedColumn!=='createdDate')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>

                                            </Grid>
                                        </Grid>


                                        {/*Repairs List */}
                                        {
                                            (currentDataOpen) && currentDataOpen.map(
                                                (item, index) => {
                                                    // (item && item.resident && item.resident.zoneName)
                                                    const residentName = (item.resident && item.resident.name) ? item.resident.name : 'N/A';
                                                    const residentLastName = (item.resident && item.resident.lastName) ? item.resident.lastName : '';
                                                    const residentZoneName = (item.resident && item.resident.zoneName) ? item.resident.zoneName : '';
                                                    const roomName = (item.room && item.room.name)? item.room.name: '';

                                                    const finalZoneName = (item && item.isCommonArea)?  roomName: residentZoneName;
                                                    const finalRoomName = (item && item.isCommonArea)? '-': roomName

                                                    // const names = residentName.split(' ').map(name => name.substring(0,1));
                                                    // const inital = names[0]?names[0] :'' +' '+ names[1]? names[1]:+''; 

                                                    return (
                                                        < Grid container  key={'repair_open' + item._id} id={`Repairs_row_${item._id}`} className="RepairsRow" onClick={() => {
                                                            this.setState({ openRepairDetails: true, repairSelectedForDetails: item, repairSelectedForDetailsStatus: item.status, repairsSelected: [item] },
                                                                () => {
                                                                    this.SetHeaderButtons({
                                                                        tabValue: this.state.tabValue,
                                                                        repairSelectedForDetailsStatus: item.status,
                                                                        repairsSelected: [item],
                                                                    })
                                                                }
                                                                )
                                                            }}
                                                            style={{overflow:'hidden', textOverflow:'ellipsis'}}
                                                        >
                                                            {
                                                                (currentDataOpen && currentDataOpen.length === index+1) && this.state.stillOpen?
                                                                    <Grid item container xs={12}
                                                                        data-lastelementopen={(currentDataOpen && currentDataOpen.length === index +1)? 'Last_Element_Open':undefined} 
                                                                        ref={currentDataOpen.length === index + 1?this.lastOpenRef:undefined} 
                                                                    />
                                                                :
                                                                    undefined
                                                            }
                                                            <Grid item container className=" CheckboxBlue RepairsCell" xs={1} justify='center' alignContent="center" >
                                                                <Grid item>
                                                                    <Checkbox
                                                                        className='CheckboxBlue'
                                                                        checked={this.state.repairsSelected && this.state.repairsSelected.length > 0 ? this.state.repairsSelected.find(repair => repair._id === item._id) !== undefined ? true : false : false}
                                                                        onChange={(e) => { this.ToogleCheckBoxHandler(item) }}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        icon={<CheckBoxOutlineBlankIcon  fontSize="large" />}
                                                                        checkedIcon={<CheckBoxIcon style={{color: '#009edd' }} fontSize="large" />}
                                                                        id={`Repair_checkbox_${item._id}`}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item container xs={12} md={2}>
                                                                <this.ResidentInfoComponent residentPictureUrl ={item.resident.residentPictureUrl} residentName={residentName} lastName={residentLastName}/>
                                                            </Grid>
                                                            <Grid item container xs={12} md={2}>
                                                                <this.ResidentLocationComponent location ={finalZoneName}/>
                                                            </Grid>
                                                            <Grid item container className="RepairsCell medium-size-1" xs={1} >
                                                                {finalRoomName}
                                                            </Grid>
                                                            <Grid item container className="RepairsCell" xs={1} >
                                                                <this.RenderitemComponnet item={item} />
                                                            </Grid>
                                                            <Grid item container className="RepairsCell medium-size" xs={1} id='repairsPage_Item_Issue' style={{fontSize:'16px', color:'#d6d5d5'}}>{item.issue ? item.issue.name : ' '}</Grid>
                                                            <Grid item container className="RepairsCell" xs={2}>
                                                                <this.RenderStatusResponseComponent item={item} status={item.status} index={index}/>
                                                            </Grid>
                                                            <Grid item container className="RepairsCell" xs={2}>
                                                                <this.ResidentSubmitedDateComponent DateSubmitted={(item && item.createdDate)? item.createdDate: undefined} />
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                }
                                            )
                                        }
                                    </Grid>

                                </TabPanel>
                                {/* Closed and canceled*/}
                                <TabPanel value={this.state.tabValue} index={2} dir={'x'}>
                                    <Grid item container xs={12} className="RenderRepairsStyles">
                                        {/* Filters and search */}
                                        <Grid item container xs={12} justifyContent='flex-end' alignItems='center'>
                                            {
                                                this.state.openSearchClosed ?
                                                <Grid item container xs={10} sm={10} md={6} lg={4} style={{ marginBottom: '1rem' }}>
                                                        <TextField
                                                        id='closed_repairs_search'
                                                        item
                                                        name='Search'
                                                        placeholder="Enter search term(s) and press Enter"
                                                        value={this.state.searchClosedValue}
                                                        fullWidth
                                                        InputProps={{
                                                            disableUnderline: true,
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <img
                                                                        src='https://engage360.s3.amazonaws.com/Icons/Categories/search.svg'
                                                                        alt='search_icon'
                                                                        width='32px'
                                                                        heigth='32px'
                                                                    />
                                                                </InputAdornment>
                                                            ),
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton id='activities_clear_btn' onClick={() => this.handleResetSearch()}>
                                                                        <FontAwesomeIcon icon={faTimesCircle} color='white' size='sm' />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                        className="activities_search animate__animated animate__slideInRight"
                                                        onChange={(e) => this.setState({ searchClosedValue: e.target.value })}
                                                        onKeyDown={(e) => { if (e && e.keyCode === 13) this.handleSearch() }}
                                                    />

                                                </Grid>
                                                :
                                                <IconButton item onClick={() => this.setState({ openSearchClosed: true })} id='search_closed_btn'>
                                                        <img
                                                            src='https://engage360.s3.amazonaws.com/Icons/Categories/search.svg'
                                                            alt='search_icon'
                                                            width='30px'
                                                            height='30px'
                                                        />
                                                    </IconButton>
                                            }
                                        <IconButton 
                                            item 
                                            onClick={(e) => this.setState({ filtersClosedAnchorEl: e.currentTarget })} 
                                            id='filters_btn' 
                                        >
                                            <img
                                                src='https://engage360.s3.amazonaws.com/Icons/Categories/filter.svg'
                                                alt='filters_icon'
                                                width='30px'
                                                height='30px'
                                            />
                                        </IconButton>

                                        </Grid>

                                        {/* Titles Repairs  List*/}
                                        <Grid item container xs={12} justify='center' alignItems='center'>
                                            <Grid item xs={2} className="RepairsRowTitle">
                                                Resident
                                                <IconButton onClick={()=>this.handleSort('resident.lastName')}>
                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortClosedColumn==='resident.lastName' && this.state.sortClosedDesc)? 
                                                        faSortAlphaDown 
                                                        : 
                                                        (this.state.sortClosedColumn==='resident.lastName' && !this.state.sortClosedDesc)? 
                                                        faSortAlphaUpAlt 
                                                        : 
                                                        (this.state.sortClosedColumn!=='resident.lastName')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={2} className="RepairsRowTitle">
                                                Location
                                                <IconButton onClick={()=>this.handleSort('resident.zoneName')}>
                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortClosedColumn==='resident.zoneName' && this.state.sortClosedDesc)? 
                                                        faSortAlphaDown 
                                                        : 
                                                        (this.state.sortClosedColumn==='resident.zoneName' && !this.state.sortClosedDesc)? 
                                                        faSortAlphaUpAlt 
                                                        : 
                                                        (this.state.sortClosedColumn!=='resident.zoneName')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={1} className="RepairsRowTitle">
                                                Room
                                                <IconButton onClick={()=>this.handleSort('room.name')}>
                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortClosedColumn==='room.name' && this.state.sortClosedDesc)? 
                                                        faSortAlphaDown 
                                                        : 
                                                        (this.state.sortClosedColumn==='room.name' && !this.state.sortClosedDesc)? 
                                                        faSortAlphaUpAlt 
                                                        : 
                                                        (this.state.sortClosedColumn!=='room.name')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={2} className="RepairsRowTitle">
                                                Item
                                                <IconButton onClick={()=>this.handleSort('item.name')}>
                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortClosedColumn==='item.name' && this.state.sortClosedDesc)? 
                                                        faSortAlphaDown 
                                                        : 
                                                        (this.state.sortClosedColumn==='item.name' && !this.state.sortClosedDesc)? 
                                                        faSortAlphaUpAlt 
                                                        : 
                                                        (this.state.sortClosedColumn!=='item.name')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={1} className="RepairsRowTitle">
                                                Issue
                                                <IconButton onClick={()=>this.handleSort('issue.name')}>
                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortClosedColumn==='issue.name' && this.state.sortClosedDesc)? 
                                                        faSortAlphaDown 
                                                        : 
                                                        (this.state.sortClosedColumn==='issue.name' && !this.state.sortClosedDesc)? 
                                                        faSortAlphaUpAlt 
                                                        : 
                                                        (this.state.sortClosedColumn!=='issue.name')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={2} className="RepairsRowTitle">
                                                Response Time
                                                <IconButton onClick={()=>this.handleSort('responseTime')}>

                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortClosedColumn==='responseTime' && this.state.sortClosedDesc)? 
                                                        faSortNumericDown 
                                                        : 
                                                        (this.state.sortClosedColumn==='responseTime' && !this.state.sortClosedDesc)? 
                                                        faSortNumericUpAlt 
                                                        : 
                                                        (this.state.sortClosedColumn!=='responseTime')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={2} className="RepairsRowTitle">
                                                Date Submitted
                                                <IconButton onClick={()=>this.handleSort('createdDate')}>

                                                    <FontAwesomeIcon icon={
                                                        (this.state.sortClosedColumn==='createdDate' && this.state.sortClosedDesc)? 
                                                        faSortNumericDown 
                                                        : 
                                                        (this.state.sortClosedColumn==='createdDate' && !this.state.sortClosedDesc)? 
                                                        faSortNumericUpAlt 
                                                        : 
                                                        (this.state.sortClosedColumn!=='createdDate')? 
                                                        faSort 
                                                        :
                                                        null
                                                        } 
                                                        color='#a2a1a2' 
                                                    />
                                                </IconButton>
                                            </Grid>
                                        </Grid>

                                        {/*Repairs List */}
                                        {
                                            currentDataClose && currentDataClose.map((item, index) => {

                                                // (item && item.resident && item.resident.zoneName)
                                                const residentName = (item.resident && item.resident.name) ? item.resident.name : 'N/A';
                                                const residentLastName = (item.resident && item.resident.lastName) ? item.resident.lastName : '';
                                                const residentZoneName = (item.resident && item.resident.zoneName) ? item.resident.zoneName : '';

                                                
                                                return (
                                                    <Grid container className="RepairsRow" 
                                                        key={`repair_closed_${item._id}`}
                                                        id={`repair_closed_${item._id}`}
                                                        onClick={() => {
                                                            this.setState({ openRepairDetails: true, repairSelectedForDetails: item, repairSelectedForDetailsStatus: item.status, repairsSelected: [item] })
                                                            this.SetHeaderButtons({
                                                                tabValue: this.state.tabValue,
                                                                repairSelectedForDetailsStatus: item.status,
                                                                repairsSelected: [item],
                                                            });
                                                        }}
                                                        style={{overflow:'hidden', textOverflow:'ellipsis'}}

                                                    >
                                                        {
                                                            (currentDataClose && currentDataClose.length === index+1) && this.state.stillClose?
                                                                <Grid item container xs={12} data-lastelementclose={(currentDataClose && currentDataClose.length === index +1)? 'Last_Element_Close':undefined} ref={currentDataClose.length === index + 1?this.lastCloseRef:undefined}/>
                                                                :
                                                                undefined
                                                        }
                                                        <Grid item container xs={12} md={2}>
                                                            <this.ResidentInfoComponent residentPictureUrl ={item.resident.residentPictureUrl} residentName={residentName} lastName={residentLastName}/>
                                                        </Grid>
                                                        <Grid item container xs={12} md={2}>
                                                            <this.ResidentLocationComponent location ={residentZoneName}/>
                                                        </Grid>
                                                        <Grid item container className="RepairsCell medium-size-1" xs={1} >
                                                            {item.room.name}
                                                        </Grid>
                                                        <Grid item container className="RepairsCell" xs={2} >
                                                            <this.RenderitemComponnet item={item} />
                                                        </Grid>
                                                        <Grid item container className="RepairsCell medium-size" xs={1} id='repairsPage_Item_Issue' style={{fontSize:'16px', color:'#d6d5d5'}}>{item.issue ? item.issue.name : ' '}</Grid>
                                                        <Grid item container className="RepairsCell" xs={2}>
                                                            <this.RenderStatusResponseComponent item={item} status={item.status} />
                                                        </Grid>
                                                        <Grid item container className="RepairsCell" xs={2}>
                                                            <this.ResidentSubmitedDateComponent DateSubmitted={(item && item.createdDate)? item.createdDate: undefined} />
                                                        </Grid>
                                                    </Grid>
                                                        
                                                )
                                            })
                                        }

                                    </Grid>

                                </TabPanel>
                            </SwipeableViews>
                        </Grid>
                        :
                        <RepairDetails
                            repairSelectedForDetails={repairSelected}
                            isCommonRoom={undefined}
                            repairSelectedForDetailsStatus={this.state.repairSelectedForDetailsStatus ? this.state.repairSelectedForDetailsStatus : repairSelected.orderStatus}
                            onAddView = {this.getAllRepairsOnAddView}
                        />
                }
            </>                
        )

    }
    //#endregion

       //#region Modal Inner Components

       RenderModalDayComponent = ({ daysToAdd }) => {

        let day = "";
        if (this.state.stepCounter === 0)
            day = moment(new Date()).add(daysToAdd, 'days');
        else
            day = moment(new Date()).add(daysToAdd + 7, 'days');


        const today = moment(new Date());
        const scheduleDay = this.state.scheduleDay ? this.state.scheduleDay : undefined;
        const sameDay = day.format('yyyy/MM/DD') === today.format('yyyy/MM/DD') ? true : false;
        const isScheduleDay = scheduleDay ? scheduleDay.format('yyyy/MM/DD') === day.format('yyyy/MM/DD') : false;

        return (
            <Grid id={`Schedule_repair_day_${daysToAdd}`} item className={day < today ? "scheduleModalDisabledCell" : "scheduleModalCell"} onClick={() => this.handleDayClick(day, today)}>
                <Grid item className="dayTitle">{day.format('ddd').toUpperCase()}</Grid>
                <Grid item className={isScheduleDay ? "ScheduleModalDate scheduleModalScheduleDay" : sameDay ? "ScheduleModalDate scheduleModalToday" : "ScheduleModalDate"}>{day.format('D')}</Grid>
            </Grid>
        );
    };

    //#endregion

    //#region Inner Components   
    RenderitemComponnet = ({ item }) => {
        let itemName = (item && item.item && item.item.name) ? item.item.name : '';
        const itemIconUrl = (item && item.item && item.item.iconUrl)? item.item.iconUrl : ''

        if (itemName) {
            itemName = itemName.charAt(0).toUpperCase() + itemName.slice(1);
        }

        return (
            <Grid item container direction='column' id='repairsPage_Item'>
                <Grid item className="center" id='repairsPage_Item_Image'>
                    <img alt={'icon Item ' + itemName} src={itemIconUrl} className="itemIcon" />
                </Grid>
                <Grid item className="center small" id='repairsPage_Item_Name'>
                    {itemName}
                </Grid>
            </Grid>
        )
    };

    RenderStatusResponseComponent = ({ item, status }) => {
        const createdDate = item.createdDate ? item.createdDate : undefined;
        const scheduleDate = item.timeLine ? item.timeLine.find(item => item.title === 'Scheduled Date') : undefined;
        const today = new Date();
        const responseTime = (item.orderStatus === 'completed' && item.createdDate && item.repairDate) ? this.GetResponseTime(item.createdDate, item.repairDate) : 'N/A';

        let beforeYesterday = true;

        if (today && createdDate) {
            beforeYesterday = moment(today).subtract(1, 'day') >= moment(createdDate);
        }


        return (
            <Grid item container xs={12} id='repairsPage_Status'>
                {
                    item.orderStatus === 'pending' || item.orderStatus==='scheduled' ?
                        <Grid item container direction='column' justify='center' alignItems='center'>
                            <Grid item style={scheduleDate ? { color: '#048ec5' } : beforeYesterday ? { color: '#ac4c5c' } : { color: 'white' }} className="large-1">
                                {!scheduleDate ? 'Opened' : 'Scheduled for'}
                            </Grid>
                            <Grid item className="medium-size-1">
                                {
                                    scheduleDate ?
                                        moment(scheduleDate.timeLineDate).format('M/D hh:mm A')
                                        :
                                        // createdDate ?
                                        //     moment(new Date(createdDate)).format('M/D hh:mm A')
                                        //     :
                                            ' '
                                }
                                { }
                            </Grid>
                        </Grid>
                        :
                        item.orderStatus === 'canceled' ?
                            <Grid item container justify='center' alignItems='center' direction='column'>
                                <Grid item className="large-1 center">{'N/A'}</Grid>
                                <Grid item className="large-1 center">{'Repair Canceled'}</Grid>
                            </Grid>
                            :
                            responseTime ?
                                <Grid item container justify='center' alignItems='center'>
                                    <Grid item className="large-1 center">{responseTime}</Grid>
                                </Grid>
                                :
                                <Grid className="large-1 center">{'N/A'}</Grid>
                }
            </Grid>
        )
    };


    //#endregion

    //#region Individual Conponents
    ResidentInfoComponent = ({ residentName, lastName}) =>{
        try{
            return(
                <Grid item container className="RepairsCell" id='repairsPage_ResidentImage' alignContent="center" justify="center">
                    <Grid item container xs={12} justify='center' alignContent='center'>
                        <Grid item className="RepairsCell large">
                            {
                                lastName?
                                `${lastName}, ${residentName}`
                                :
                                residentName
                            }
                            {/* {
                                (residentPictureUrl && residentPictureUrl !== 'https://engage360.s3.amazonaws.com/Residents/profile.png') ?
                                    <img
                                        className="ResidentImage"
                                        src={residentPictureUrl}
                                        alt={(residentName) ? residentName : ''}
                                    />
                                    :
                                    (residentName) ?
                                        <Grid item className="ResidentImage">
                                            {inital}
                                        </Grid>
                                        :
                                        ''
                            } */}
                        </Grid>
                    </Grid>
                </Grid>
            );
        }catch(err){
            return(
                <Grid item container>
                </Grid>
            )
        }
    }

    ResidentLocationComponent = ({location}) =>{
        try{
            return(
                <Grid item container alignContent="center" justify="center">
                    <Grid item  className="RepairsCell large" id='repairsPage_Location' style={{fontSize:'16px', color:'#d6d5d5'}}>
                        {location ? location : ''}
                    </Grid>
                </Grid>
            );
        }catch(err){
            return(
                <Grid item container></Grid>
            );
        }
    }

    ResidentSubmitedDateComponent = ({DateSubmitted}) =>{
        try{
            const date = new moment(DateSubmitted);
            let dateFormated = undefined;

            if(date && date._isValid){
                dateFormated= date.format('MM/DD/yyyy');
            }

            return(
                <Grid item container justify="center" alignContent="center" style={{fontSize:'16px', color:'#d6d5d5'}}>
                    <Grid item>
                        {dateFormated}
                    </Grid>
                </Grid>
            );
        }catch(err){
            return(
                <Grid item container></Grid>
            );
        }
    }

 
    //#endregion

   

    render() {

        const shouldReturnToHome = (this.props.returnToHome && this.props.returnToHome ==='true')? true: false;
        if(this.props.UpdateCurrentLocation && shouldReturnToHome){

            this.setState(
                {
                    tabValue:0
                },
                () =>{
                this.SetHeaderButtons({tabValue:0});
                this.props.UpdateCurrentLocation('false');
            })
        }
    

        
        const week = [0, 1, 2, 3, 4, 5, 6];
        

        if (this.state.superUserCommunitySelected && (!this.state.superUserActivitiesLoaddedForCommunity || (this.state.superUserActivitiesLoaddedForCommunity !== this.state.superUserCommunitySelected))) {
            this.getRepairs();
            this.setState({ superUserActivitiesLoaddedForCommunity: this.state.superUserCommunitySelected });
        }

        const onArrowClick = (order, placeHolder) => {


            if (placeHolder === 'hr') {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                let hour = hourObject.number ? hourObject.number : 0;

                if (order === 'Up') {

                    if ((hour + 1) < 13) {
                        hour = hour + 1;
                    }
                }
                else {
                    if ((hour - 1) > 0) {
                        hour = hour - 1;
                    }
                }

                hourObject.number = hour;
                hourObject.text = ('0' + hour).slice(-2);

                this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
            }

            if (placeHolder === 'min') {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                let minute = minuteObject.number ? minuteObject.number : 0;
                if (order === 'Up') {

                    if ((minute + 1) < 60) {
                        minute = minute + 1;
                    }
                }
                else {
                    if ((minute - 1) > -1) {
                        minute = minute - 1;
                    }
                }

                minuteObject.number = minute;
                minuteObject.text = ('0' + minute).slice(-2)

                this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
            }

            if (placeHolder === 'AM') {
                let dayTime = 'AM';
                if (this.state.dayTime === undefined || this.state.dayTime.text === 'PM') {
                    dayTime = 'AM';
                }
                else {
                    dayTime = 'PM';
                }

                this.setState({ dayTime: { text: dayTime }, fixedOptionSelected: undefined });
            }
        }

        return (

            <main className="content-engage-Repairs" >
                <div >
                    {
                         (this.state.showAddRepairView)?
                         <Grid item container xs={12}>
                             <AddRepairView
                                onCancel={this.CancelAddRequestHandler}
                             />
                         </Grid>
                         :
                        <Grid item container xs={12}>
                            <this.RenderTabsFullContent/>
                        </Grid>
                    }
                    <Modal
                        open={this.state.showScheduleRepairModal}
                        onClose={() => this.CleanScheduleModal()}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                    >
                        <Grid>
                            <Paper elevation={3} className="paperModalRepairs" square='false' color='secondary'>
                                <Grid container justify='flex-start' alignItems='baseline' style={{ height: '100%' }}>
                                    <Grid item container alignItems='center' className="TitleRepairsModal">Schedule Repair</Grid>
                                    <Grid item container className="RepairsScheduleModalContainer" alignItems='center' justify='center'>
                                        {/* fixed options */}
                                        <Grid item container xs={12} justify='center' alignItems='center' className="fixedOptionContainer">
                                            <Grid id='Schedule_modal_now_option' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 1) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForRepair(moment(new Date()), 1)}>Now</Grid>
                                            {
                                                moment(new Date()).hour() < 12 ?
                                                    <Grid id='Schedule_modal_noon_today_option' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 2) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForRepair(moment(new Date()).startOf('day').add(12, 'hours'), 2)}>Noon Today</Grid>
                                                    :
                                                    undefined
                                            }
                                            {
                                                moment(new Date()).day() !== 6 ?
                                                    <Grid id='Schedule_modal_noon_tomorrow_option' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 3) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForRepair(moment(new Date()).add(1, 'days').startOf('day').add(12, 'hours'), 3)}>Noon Tomorrow</Grid>
                                                    :
                                                    undefined
                                            }
                                        </Grid>
                                        <Grid item container xs={12} alignItems='center' justify='center' className="contentModal">
                                            <Grid item container xs={1} justify='center' alignItems='center'>
                                                <IconButton id='device_messageModal_schedulemessage_backwardarrow' aria-label="leftArrow" onClick={() => this.AddStep(-1)} disabled={this.state.disabledBackIcon}>
                                                    <ArrowBackIosIcon style={{ fontSize: 40, color: (this.state.disabledBackIcon === false) ? '#f0efef' : '#1f1f1f' }} />
                                                </IconButton>
                                            </Grid>
                                            <Grid item container xs={10} alignItems='center' justify='center' className="daysRow">
                                                {
                                                    week ? week.map(
                                                        day => {
                                                            return (
                                                                <this.RenderModalDayComponent key={'DayComponent' + day} daysToAdd={day} />
                                                            );
                                                        }
                                                    ) :
                                                        undefined
                                                }
                                            </Grid>
                                            <Grid item container xs={1} justify='center' alignItems='center'>
                                                <IconButton id='device_messageModal_schedulemessage_forwardarrow' aria-label="RightArrow" onClick={() => this.AddStep(1)} disabled={this.state.disabledFowardIcon}>
                                                    <ArrowForwardIosIcon style={{ fontSize: 40, color: (this.state.disabledFowardIcon === false) ? '#f0efef' : '#1f1f1f' }} />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                        <Grid item container xs={12} justify='center' alignItems='center' className="contentModalNoOpacity">
                                            {/* Time Selection */}
                                            <Grid item container xs={9} justify='space-between' className="scheduleModalTimeList">
                                                <Grid item container xs={4}>
                                                    <ChevronList
                                                        idToSet='Schedule_repair_hr'
                                                        onArrowClick={onArrowClick}
                                                        onChangeHandler={this.onChangeHandler}
                                                        optionSelected={this.state.hourSelected}
                                                        placeHolder='hr'
                                                    />
                                                </Grid>
                                                <Grid item xs={1} className="ModalColon">:</Grid>
                                                <Grid item xs={4}>
                                                    <ChevronList
                                                        idToSet='Schedule_repair_min'
                                                        onArrowClick={onArrowClick}
                                                        onChangeHandler={this.onChangeHandler}
                                                        optionSelected={this.state.minuteSelected}
                                                        placeHolder='min'
                                                    />
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ChevronList
                                                        onArrowClick={onArrowClick}
                                                        onChangeHandler={this.onChangeHandler}
                                                        optionSelected={this.state.dayTime}
                                                        placeHolder='AM'
                                                        idToSet='Schedule_repair_AM-PM'
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {/* Buttons */}
                                        <Grid item container className="scheduleModalButtonsContainer alingCenter" direction='row'>
                                            <Grid item container className="RepairsModalButtonCancel alingCenter">
                                                <Grid id='Schedule_modal_cancel_btn' item container className="alingCenter" onClick={() => this.CleanScheduleModal()}>
                                                    Cancel
                                                </Grid>
                                            </Grid>
                                            <Grid item container
                                                className={(this.state.scheduleDay === undefined || this.state.dayTime === undefined || this.state.minuteSelected === undefined || this.state.hourSelected === undefined) ? "RepairsModalButtonSchedule-Disabled alingCenter" : "RepairsModalButtonSchedule alingCenter"}>
                                                <Grid id='Schedule_modal_schedule_btn' item container className="alingCenter" onClick={() => this.MakeRepairDate()}>
                                                    Schedule
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Modal>

                    <Modal
                        open={this.state.showModalCloseRepairs}
                        onClose={() => this.CleanCloseRepairsModal()}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ borderRadius: '16px' }}
                    >
                        <ModalCloseRepairs
                            actions={this.state.repairsSelected ? this.state.repairsSelected : []}
                            OnCancelHandler={this.OnCancelHandler}
                            OnCloseHandler={this.OnCloseHandler}
                            OnCancelRepairs={this.OnCancelRepairs}
                            isCancel={this.state.isCancel}
                        />
                    </Modal>

                    {
                        this.state.filtersOpenedAnchorEl &&
                        <RepairsFilters
                            anchorEl={this.state.filtersOpenedAnchorEl}
                            onClose={() => this.setState({ filtersOpenedAnchorEl: null })}
                            filters={this.state.filtersOpenedObj}
                            tab={this.state.tabValue}
                            applyFilters={this.applyFilters}
                            resetFilters={this.resetFilters}
                        />
                    }

                    {
                        this.state.filtersClosedAnchorEl &&
                        <RepairsFilters
                            anchorEl={this.state.filtersClosedAnchorEl}
                            onClose={() => this.setState({ filtersClosedAnchorEl: null })}
                            filters={this.state.filtersClosedObj}
                            tab={this.state.tabValue}
                            applyFilters={this.applyFilters}
                            resetFilters={this.resetFilters}
                        />
                    }
                </div>
            </main >
        )
    }
}

function mapStateToProps(state, dispatch) {
    let communityData = (state.communityReducer && state.communityReducer.communityData) ? state.communityReducer.communityData : [];
    const repairData = (state.repairReducer && state.repairReducer.repairData) ? state.repairReducer.repairData : [];
    const dashboardRepairData = (state.repairReducer && state.repairReducer.dashboardRepairData) ? state.repairReducer.dashboardRepairData : [];
    let currentDataOpen = (state.repairReducer?.dashboardRepairData?.openS)?state.repairReducer?.dashboardRepairData?.openS : []
    let currentDataClose = (state.repairReducer?.dashboardRepairData?.closeS)?state.repairReducer?.dashboardRepairData?.closeS : []
    const openRepairs = (state.repairReducer && state.repairReducer.openRepairs) ? state.repairReducer.openRepairs : [];
    const closedRepairs = (state.repairReducer && state.repairReducer.closedRepairs) ? state.repairReducer.closedRepairs : [];


    let returnToHome = (state && state.currentUrlReducer && state.currentUrlReducer.returnToHome)? state.currentUrlReducer.returnToHome :  'false'
    
    currentDataOpen = currentDataOpen.map((r) => {
        let newRepair= r

        if(newRepair && newRepair.resident && !newRepair.resident.name && !newRepair.resident.lastName){
            newRepair.resident.name = 'N/A'
        }
        
        return newRepair
    })

    currentDataClose = currentDataClose.map((r) => {
        let newRepair= r

        if(newRepair && newRepair.resident && !newRepair.resident.name  && !newRepair.resident.lastName){
            newRepair.resident.name = 'N/A'
        }
        
        return newRepair
    })

    if (communityData) {
        communityData =
            communityData.map(item => ({ _id: item._id, name: item.communityName, communityId: item.communityId }));
    }

    if (communityData) {
        communityData =
            communityData.map((item, index) => {
                item.indexForCombo = index;
                return item;
            })
    }

    return {
        tableData: repairData,
        repairTableData: dashboardRepairData,
        currentDataClose, 
        currentDataOpen,
        communityData: communityData,
        returnToHome: returnToHome,
        openRepairs,
        closedRepairs
        // itemsIconsData: itemsIconsData,
    }
}


Repairs = reduxForm({
    form: 'RepairForm',
    enableReinitialize: true,
})(Repairs);

export default connect(mapStateToProps, { 
    getAllRepairs, getOpenRepairs, getCloseRepairs, updRepair, CloseRepairs, getAllItemsIcons, 
    ScheduleWorkOrder, CancelRepairs, getHistoricDashboard, SetHeaderButtons, 
    getAllCommunities, UpdateCurrentLocation, GetRepairsFilters 
})(Repairs);

